import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../config";
import {
  IApiLoopingResponse,
  IApiResponse,
  IApiResponseForPunch,
  ICategoryPayload,
  IEmployeePunchImgPayload,
  IGetByCategoryArrayPayload,
  IGetByCategoryPayload,
  ILoopingTableListPayload,
  IProductPayload,
  ISearchIsActivePayload,
  ISearchPayload,
  ITeamListPayload,
  ITenatListPayload,
  IUser,
  PrivilegesResponse,
  IItemStorePayload,
  IItemStoreUpdatePayload,
  IOrderListHitoryPayload,
  IOrderListStatusPayload,
  IProductPayload2,
  ICheckMainItemNamePayload,
  ICheckMainItemNameEditPayload,
  IProductPayload4,
  ICategoryPayload2,
  ISearchTagPayload,
  IApiResponsePunchDashboard,
  IApiTenantResponse,
  IEmployeeScheduleDetailsPayload,
  IApiPayrollResponse,
  IPayrollPayload,
  IReSchedulPayload,
  IPayrollAnEmpPayloadSec,
  IApiPayrollAllResponse,
  IPayrollListApiResponse,
  ISavePayrollAnEmpPayload,
  ISavePayrollAnEmpEachRecordPayload,
  IPayrollAnEmpPayload,
  IDayAnEmpEachRecordPayload,
  IGetRent,
  IDayEmpReportPayload,
  IPayrollPayloadWeeklyReport,
  IApiPayrollGenerateResponse,
  IApiResponseDhashboard,
  ITeamListHistoryRecordPayload,
  IGroupedOrderListResponse,
  ICheckProductStoreHistoPayload,
  IOrderListHitoryPayload2,
  IApiReceiptResponse,
  IApiResponseDhashbordClient,
  IIdOnlyPayload,
  IEmailRecordPayload,
  IApiSettingResponse,
  IIdOnlyNumberPayload,
  IPayrollAnEmpPayloadSec2,
  IPayrollEmployee,
  IPriceListPayload
} from "./Interface/api.interface";
/**
 * Holds all the API callbacks
 * @returns RTK Implementation for backend
 */

export const attoDeskApi = createApi({
  reducerPath: "attoDeskApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set(
        "Authorization",
        `Bearer ${localStorage.getItem("token") || ""}`
      );
      return headers;
    },
  }),
  tagTypes: [
    "User",
    "print",
    "Setting",
    "department",
    "printer",
    "category",
    "product",
    'looping',
    'productGetByCategory',
    'productCategory',
    'store',
    "User",
    "dashboard",
    "OrderList",
    "UserRole",
    "Privilege",
    "restaurant",
    "themeColor",
    "tax",
    "tag",
    "brand",
    "team",
    'PunchDetails',
    "EmployeeSchedule",
    "Position",
    "Payroll",
    "Reschedule",
    "email",
    "supplier",
    "capacity",
    "grade",
    "PriceCheckList",


  ],
  endpoints: (builder) => ({
    getUser: builder.query<IApiResponse, void>({
      query: (request) => {
        return {
          url: "/user/userInfo",
          method: "POST",
          body: request,
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["User"],
    }),
    login: builder.mutation<IApiResponse, IUser>({
      query: (request) => {
        return {
          url: "/login",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
    }),
    getSetting: builder.query<IApiResponse, ITenatListPayload>({
      query: (request) => {
        return {
          url: "/setting/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Setting"],
      keepUnusedDataFor: 0,
    }),
    createSetting: builder.mutation<IApiSettingResponse, Object>({
      query: (request) => {
        return {
          url: "/setting",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Setting"],
    }),
    createDepartment: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/department",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["department"],
    }),
    deleteDepartment: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/department/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["department"],
    }),
    getDepartment: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/department/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["department",],
      keepUnusedDataFor: 0,
    }),
    createPrinter: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/printer",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["printer"],
    }),
    deletePrinter: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/printer/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["printer"],
    }),
    getPrinter: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/printer/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["printer", "department"],
      keepUnusedDataFor: 0,
    }),
    createCategory: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/category',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['category'],
    }),
    createLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/looping/create-table',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['looping','product'],
    }),
    getAllLoopingTable: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: '/looping/list-tables',
          method: "POST",
          body: request,
        };
      },
      providesTags:['looping', 'product'],
      keepUnusedDataFor: 0,
    }),
    deleteLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/looping/delete-table',
          method: 'DELETE',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['looping','product'],
    }),
    updateLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/looping/update-table',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['looping','product'],
    }),
    insertOrUpdateDataLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/looping/table/insert-update-data',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['product', 'looping'],
    }),
    getAllMainCategory: builder.query<IApiResponse, ICategoryPayload>({
      query: (request) => {
        return {
          url: '/main-category/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags: ['product', "category"],
      keepUnusedDataFor: 0,
    }),
    getAllMainCategory2: builder.query<IApiResponse, ICategoryPayload2>({
      query: (request) => {
        return {
          url: '/main-category/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags: ['product', "category"],
      keepUnusedDataFor: 0,
    }),
    getSubCategoryByArray: builder.query<IApiResponse, IGetByCategoryArrayPayload>({
      query: (request) => {
        return {
          url: '/category/category-fiter/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['productGetByCategory', 'product', 'productCategory'],
      keepUnusedDataFor: 0,
    }),
    getLoopingTable: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: '/looping/list-tables',
          method: "POST",
          body: request,
        };
      },
      providesTags:["category", 'product', 'looping'],
      keepUnusedDataFor: 0,
    }),
    getAllCategoryName: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: '/all-category/getAll',
          method: 'POST',
        };
      },
      providesTags: ['productCategory'],
      keepUnusedDataFor: 0,
    }),
    deleteCategory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/category/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['category', 'productCategory'],
    }),
    createProduct: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: '/product',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['product'],
    }),
    getLastProductId: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: '/product/last-id',
          method: 'GET',
        };
      },
      providesTags: ['product' ],
      keepUnusedDataFor: 0,
    }),
    getSubCategoryByCategoryId: builder.query<IApiResponse, IGetByCategoryPayload>({
      query: (request) => {
        return {
          url: '/product/get-by-categories',
          method: "POST",
          body: request,
        };
      },
      providesTags:['productGetByCategory', 'product'],
      keepUnusedDataFor: 0,
    }),
    deleteProduct: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['product'],
    }),
    getProduct: builder.query<IApiResponse, IProductPayload2>({
      query: (request) => {
        return {
          url: '/product/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags: [ 'product'],
      keepUnusedDataFor: 0,
    }),
    getProductCategory: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: '/product/category/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['productCategory','product'],
      keepUnusedDataFor: 0,
    }),
    getCategory: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: '/category/getAll',
          method: 'POST',
        };
      },
      providesTags: ['product', "category"],
      keepUnusedDataFor: 0,
    }),
    createStore: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/store",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["store"],
    }),
    deleteStore: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/store/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["store"],
    }),
    getStore: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/store/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["store",],
      keepUnusedDataFor: 0,
    }),
    GetAllUserPrivileges: builder.query<PrivilegesResponse, void>({
      query: (request) => {
        return {
          url: "/privilege/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["User",],
      keepUnusedDataFor: 0,
    }),
    createUser: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["User"],
    }),
    getUserAdminOny: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/user/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["User",],
      keepUnusedDataFor: 0,
    }),
    deleteUser: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/user/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["User"],
    }),
    changeUserPassword: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/change-password",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["User"],
    }),
    updateUserPrivileges: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/update-privileges",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["User"],
    }),
    getMissingPunchOut: builder.query<IApiResponse, void>({
      query: (request) => {
        return {
          url: "/missing/punch-out",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["dashboard"],
      keepUnusedDataFor: 0,
    }),
    GetStoreItemByCategory: builder.query<IApiResponse, IItemStorePayload>({
      query: (request) => {
        return {
          url: "/store/item/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["category","product"],
      keepUnusedDataFor: 0,
    }),
    GetStoreItemByCategoryUpdated: builder.query<IApiResponse, IItemStoreUpdatePayload>({
      query: (request) => {
        return {
          url: "/store/item/update/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["category","product"],
      keepUnusedDataFor: 0,
    }),
    createOrderList: builder.mutation<IApiResponseForPunch, Object>({
      query: (request) => {
        return {
          url: "/order/list",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["OrderList"],
    }),
    getLastOrderListId: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/order-list/next-id",
          method: "GET",
        };
      },
      providesTags: ["OrderList"],
      keepUnusedDataFor: 0,
    }),
    getOrderList: builder.query<IApiResponse, IOrderListStatusPayload>({
      query: (request) => {
        return {
          url: "/order-list/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["OrderList"],
      keepUnusedDataFor: 0,
    }),
    getAllGetOrderListHistory: builder.query<IApiResponse, IOrderListHitoryPayload>({
      query: (request) => {
        return {
          url: '/order/list/History/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags: ['OrderList'],
      keepUnusedDataFor: 0,
    }),
    createOrderListEdit: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/order/list/edit",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["OrderList"],
    }),
    deleteOrderListHistory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/order-list/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["OrderList"],
    }),
    createUserRole: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/role",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["UserRole", "User"],
    }),
    deleteUserRole: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/user/role/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["UserRole", "User"],
    }),
    getUserRole: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/user/role/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["UserRole", "User"],
      keepUnusedDataFor: 0,
    }),
    createUserPrivilege: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/privilege",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Privilege","UserRole", "User"],
    }),
    deleteUserPrivilege: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/user/privilege/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Privilege","UserRole", "User"],
    }),
    getUserPrivilege: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/user/privilege/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Privilege", "UserRole","User"],
      keepUnusedDataFor: 0,
    }),
    changeStatusOrderListSentToManager: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/order-list/change/status/step2/${Id}`,
          method: "POST",
        };
      },
      invalidatesTags: ["OrderList"],
    }),
    sentToManagerOrderList: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/order/list/sent-To-Manager/edit",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["OrderList"],
    }),
    getOrderListById: builder.query<IApiResponse, ITeamListPayload>({
      query: (request) => {
        return {
          url: "/order-list/id/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["OrderList"],
      keepUnusedDataFor: 0,
    }),
    adminChangeStatus: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/admin/change/status",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["OrderList"],
    }),
    getAllAdminOrderList: builder.query<IApiResponse, IOrderListStatusPayload>({
      query: (request) => {
        return {
          url: "/admin/order/list/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["OrderList"],
      keepUnusedDataFor: 0,
    }),
    adminConformStorePrice: builder.query<IApiResponse, IEmployeePunchImgPayload>({
      query: (request) => {
        return {
          url: "/admin/order/list/price/list",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["OrderList"],
      keepUnusedDataFor: 0,
    }),
    getRestaurant: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/restaurant/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["restaurant"],
      keepUnusedDataFor: 0,
    }),
    createRestaurant: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/restaurant",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["restaurant"],
    }),
    deleteRestaurant: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/restaurant/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["restaurant"],
    }),
    deleteRestaurantSchedule: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/restaurant/schedule/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["restaurant"],
    }),
    getDashboardSecSectionOrderList: builder.query<IApiResponse, void>({
      query: (request) => {
        return {
          url: "/dashboard/sec/section/order/list/getAll",
          method: "POST",
          body: request,
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["dashboard"],
    }),
    getMainItem: builder.query<IApiResponse, IProductPayload>({
      query: (request) => {
        return {
          url: '/main/item/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags: [ 'product'],
      keepUnusedDataFor: 0,
    }),
    getMainItem2: builder.query<IApiResponse, IProductPayload4>({
      query: (request) => {
        return {
          url: '/main/item/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags: [ 'product'],
      keepUnusedDataFor: 0,
    }),
    createMainItem: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: '/main/item',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['product'],
    }),
    checkMainItemName: builder.query<IApiResponse, ICheckMainItemNamePayload>({
      query: (request) => {
        return {
          url: "/main/item/check/name",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
    checkMainItemNameEdit: builder.query<IApiResponse, ICheckMainItemNameEditPayload>({
      query: (request) => {
        return {
          url: "/main/item/check/name/edit",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
    deleteMainItem: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/main/item/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['product'],
    }),
    getProductWithStore: builder.query<IApiResponse, IProductPayload2>({
      query: (request) => {
        return {
          url: '/product/getAll/with/store',
          method: "POST",
          body: request,
        };
      },
      providesTags: [ 'product'],
      keepUnusedDataFor: 0,
    }),
    getUserInfoOny: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/user/getAll/info",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["User"],
      keepUnusedDataFor: 0,
    }),
    createLightThemeColor: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/light/theme/color",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["themeColor"],
    }),
    getAllLightThemeColor: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/light/theme/color/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["themeColor"],
      keepUnusedDataFor: 0,
    }),
    createDarkThemeColor: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/dark/theme/color",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["themeColor"],
    }),
    getAllDarkThemeColor: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/dark/theme/color/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["themeColor"],
      keepUnusedDataFor: 0,
    }),
    createTax: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/tax',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['tax', 'product', 'category'],
    }),
    deleteTax: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/tax/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['tax'],
    }),
    getTax: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: '/tax/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['tax', "category", 'product'],
      keepUnusedDataFor: 0,
    }),
    createTag: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/tags',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['tag', 'product'],
    }),
    deleteTag: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/tags/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['tag'],
    }),
    getTag: builder.query<IApiResponse, ISearchTagPayload>({
      query: (request) => {
        return {
          url: '/tags/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['tag', 'product'],
      keepUnusedDataFor: 0,
    }),
    createBrand: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/brand',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['brand', 'product'],
    }),
    deleteBrand: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/brand/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['brand'],
    }),
    getBrand: builder.query<IApiResponse, ISearchTagPayload>({
      query: (request) => {
        return {
          url: '/brand/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['brand', 'product'],
      keepUnusedDataFor: 0,
    }),
    createLightThemeColorOder: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/light/theme/color/order",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["themeColor"],
    }),
    createDarkThemeColorOrder: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/dark/theme/color/order",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["themeColor"],
    }),
    createTeam: builder.mutation<IApiTenantResponse, Object>({
      query: (request) => {
        return {
          url: "/team",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["team"],
    }),
    getTeam: builder.query<IApiResponse, ITeamListPayload>({
      query: (request) => {
        return {
          url: "/team/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    deleteTeam: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/team/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["team"],
    }),
    getPunchDetails: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/punch/details/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getPunchDashboard: builder.query<IApiResponsePunchDashboard, void>({
      query: (request) => {
        return {
          url: "/dashboard/punch/details",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["PunchDetails",],
      keepUnusedDataFor: 0,
    }),
    deleteEmployeeSchedule: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/employee/schedule/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["team"],
    }),
    getEmployeeScheduleDetails: builder.query<IApiResponse, IEmployeeScheduleDetailsPayload>({
      query: (request) => {
        return {
          url: "/employee/schedule/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getEmployeeScheduleDetailsByDate: builder.query<IApiResponse, IEmployeeScheduleDetailsPayload>({
      query: (request) => {
        return {
          url: "/employee/schedule/date/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getEmployeeImg: builder.query<IApiResponseForPunch, IEmployeePunchImgPayload>({
      query: (request) => {
        return {
          url: "/punch/details/get-img",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    createPosition: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/position",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Position"],
    }),
    deletePosition: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/position/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Position"],
    }),
    getPosition: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/position/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Position",],
      keepUnusedDataFor: 0,
    }),
    getEmployeePayRoll: builder.query<IApiPayrollResponse, IPayrollPayload>({
      query: (request) => {
        return {
          url: "/team/payroll/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    createAdminEditPunch: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/punch/details/admin/edit",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PunchDetails"],
    }),
    
    getEmployeePayRollAdmin: builder.query<IApiPayrollResponse, IPayrollPayload>({
      query: (request) => {
        return {
          url: "/punch/record/payroll-generate",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getlastUpdateDatePayroll: builder.query<IApiPayrollResponse, void>({
      query: (request) => {
        return {
          url: "/last-update/payroll-date",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    createReschedule: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/emp/schedule/record",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Reschedule"],
    }),
    deleteReschedule: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/emp/schedule/record/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Reschedule"],
    }),
    getReschedule: builder.query<IApiResponse, IReSchedulPayload>({
      query: (request) => {
        return {
          url: "/emp/schedule/record/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Reschedule",],
      keepUnusedDataFor: 0,
    }),
    getTeamSerchOnly: builder.query<IApiResponse, ITeamListPayload>({
      query: (request) => {
        return {
          url: "/team/search/only",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getEmployeeScheduleDetailsByDateOnly: builder.query<IApiResponse, IEmployeeScheduleDetailsPayload>({
      query: (request) => {
        return {
          url: "/employee/schedule/date/only",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    removedReschedule: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/emp/schedule/record/removed",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Reschedule"],
    }),
    getRescheduleOrderByDate: builder.query<IApiResponse, IReSchedulPayload>({
      query: (request) => {
        return {
          url: "/emp/schedule/record/getAll/orderBy/Date",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Reschedule",],
      keepUnusedDataFor: 0,
    }),
    getEmployeePayRollAdminUse: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/payroll/generate",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Payroll"],
    }),
    getAnEmployeePayRollAdmin: builder.query<IApiPayrollResponse, IPayrollAnEmpPayloadSec>({
      query: (request) => {
        return {
          url: "/punch/record/employee/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getAllPayrollList: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: '/payroll/list/getAll',
          method: 'POST',
        };
      },
      providesTags: ['Payroll'],
      keepUnusedDataFor: 0,
    }),
    getAllPayrollRecordeDateRange: builder.query<IApiPayrollAllResponse, void>({
      query: (request) => {
        return {
          url: "/payroll/record/date-range/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getSaveEmployeePayrollRecord: builder.query<IPayrollListApiResponse, IEmployeePunchImgPayload>({
      query: (request) => {
        return {
          url: "/save/payroll/List/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getSaveAnEmployeePayRollAdmin: builder.query<IApiPayrollResponse, ISavePayrollAnEmpPayload>({
      query: (request) => {
        return {
          url: "/save/punch/record/employee/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getSaveAnEmplEachRecordPayRollAdmin: builder.query<IApiPayrollResponse, ISavePayrollAnEmpEachRecordPayload>({
      query: (request) => {
        return {
          url: "/save/punch/record/employee/each",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getPunchDetailsEmp: builder.query<IApiResponse, IPayrollAnEmpPayload>({
      query: (request) => {
        return {
          url: "/punch/details/getEmp",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getSaveEmployeePayrollAnEmployeeRecord: builder.query<IApiResponse, IPayrollAnEmpPayload>({
      query: (request) => {
        return {
          url: "/save/payroll/List/emp",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    PayrollRecordeEmp: builder.query<IApiPayrollAllResponse, IPayrollAnEmpPayloadSec>({
      query: (request) => {
        return {
          url: "/payroll/list/emp",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll", "team"],
      keepUnusedDataFor: 0,
    }),
    EditEmployeePayRollAdmin: builder.query<IApiPayrollResponse, IGetRent>({
      query: (request) => {
        return {
          url: "/punch/record/edit/payroll-generate",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getDayRecordAnEmplEachRecord: builder.query<IApiPayrollResponse, IDayAnEmpEachRecordPayload>({
      query: (request) => {
        return {
          url: "/punch/record/employee/day/each",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    empPayrollPayrollRecordReport: builder.query<IApiPayrollResponse, IDayEmpReportPayload>({
      query: (request) => {
        return {
          url: "/save/payroll/List/emp/day-by-day/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    editPunchInTime: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/punch/edit/punch-in",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PunchDetails"],
    }),
    editPunchOutTime: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/punch/edit/punch-out",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PunchDetails"],
    }),
    createRescheduleUpdatedForAllDate: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/emp/schedule/record/for-all",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Reschedule"],
    }),
    getEmpScheduleDetailsByDateRange: builder.query<IApiResponse, IPayrollPayloadWeeklyReport>({
      query: (request) => {
        return {
          url: "/employee/schedule/date/range",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    createfixedPayrollGenerate: builder.mutation<IApiPayrollGenerateResponse, Object>({
      query: (request) => {
        return {
          url: "/punch/record/payroll-generate",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Payroll"],
    }),
    getEmployeePayRollAdminUseEdit: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/edit/payroll",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Payroll"],
    }),
    getDashboardFristSection: builder.query<IApiResponseDhashboard, void>({
      query: (request) => {
        return {
          url: "/dashboard/frist/section/getAll",
          method: "POST",
          body: request,
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["dashboard"],
    }),
    getDashboardSecSection: builder.query<IApiResponseDhashboard, void>({
      query: (request) => {
        return {
          url: "/dashboard/sec/section/getAll",
          method: "POST",
          body: request,
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["dashboard"],
    }),
    getOrderListHistoryRecordById: builder.query<IApiResponse, ITeamListHistoryRecordPayload>({
      query: (request) => {
        return {
          url: "/order-list/history/record",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["OrderList"],
      keepUnusedDataFor: 0,
    }),
    adminSetPriceOrderList: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/admin/orderlist/set/price",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["OrderList"],
    }),
    editOrderListUpdatedPrice: builder.query<IApiResponse, IEmployeePunchImgPayload>({
      query: (request) => {
        return {
          url: "/admin/order/list/price/list/edit",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["OrderList"],
      keepUnusedDataFor: 0,
    }),
    getAllGroupByStoreOrderListHistory: builder.query<IGroupedOrderListResponse, IOrderListHitoryPayload>({
      query: (request) => {
        return {
          url: '/order/list/History/group/By/store',
          method: "POST",
          body: request,
        };
      },
      providesTags: ['OrderList'],
      keepUnusedDataFor: 0,
    }),
    getProducStoreHistroyRecord: builder.query<IApiResponse, ICheckProductStoreHistoPayload>({
      query: (request) => {
        return {
          url: '/variant/store/history/records',
          method: "POST",
          body: request,
        };
      },
      providesTags: [ 'product'],
      keepUnusedDataFor: 0,
    }),
    getProducHistroyRecord: builder.query<IApiResponse, ICheckProductStoreHistoPayload>({
      query: (request) => {
        return {
          url: '/variant/history/records',
          method: "POST",
          body: request,
        };
      },
      providesTags: [ 'product'],
      keepUnusedDataFor: 0,
    }),
    getStoreItemOrderList: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/store/item/getAll/order/list",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["OrderList",],
      keepUnusedDataFor: 0,
    }),
    getOrderListItemByStore: builder.query<IApiResponse, IOrderListHitoryPayload2>({
      query: (request) => {
        return {
          url: '/order/list/item/By/store',
          method: "POST",
          body: request,
        };
      },
      providesTags: ['OrderList'],
      keepUnusedDataFor: 0,
    }),
    getOrderListReceipt: builder.query<IApiReceiptResponse, IOrderListHitoryPayload2>({
      query: (request) => {
        return {
          url: '/order/list/get/receipt',
          method: "POST",
          body: request,
        };
      },
      providesTags: ['OrderList'],
      keepUnusedDataFor: 0,
    }),
    orderListReceiptUpdate: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/order/list/receipt/update",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["OrderList"],
    }),
    getAllDhashboardFrist: builder.query<IApiResponseDhashbordClient, IIdOnlyPayload>({
      query: (request) => {
        return {
          url: "/dhashboard/frist",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["dashboard"],
      keepUnusedDataFor: 0,
    }),
    createEmail: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/email",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email"],
    }),
    deleteEmail: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email"],
    }),
    getEmail: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/email/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email",],
      keepUnusedDataFor: 0,
    }),
    createEmailTemplates: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/email/templates",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email"],
    }),
    deleteEmailTemplates: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email/templates/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email"],
    }),
    getEmailTemplates: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/email/templates/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email",],
      keepUnusedDataFor: 0,
    }),
    createEmailRecord: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/email/record",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email","team"],
    }),
    deleteEmailRecord: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email/record/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "team"],
    }),
    getEmailRecord: builder.query<IApiResponse, IEmailRecordPayload>({
      query: (request) => {
        return {
          url: "/email/record/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email", "team"],
      keepUnusedDataFor: 0,
    }),
    createUserStaff: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/staff",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["User", "team"],
    }),
    deleteUserStaff: builder.mutation<IApiResponse, { id: string; staffId: string }>({
      query: ({ id, staffId }) => {
        return {
          url: `/user/staff/${id}/${staffId}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["User", "team"],
    }),
    deleteAdminEditPunch: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/punch/details/admin/delete",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PunchDetails"],
    }),
    getEmployeeScheduleDetailsByMonth: builder.query<IApiResponse, IPayrollPayload>({
      query: (request) => {
        return {
          url: "/employee/schedule/month",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getCheckAttananceStatus: builder.query<IApiResponse, IIdOnlyNumberPayload>({
      query: (request) => {
        return {
          url: "/attanance/read/recipt",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getEmpScheduleDetailsByDateDeleteRecord: builder.query<IApiResponse, IEmployeeScheduleDetailsPayload>({
      query: (request) => {
        return {
          url: "/employee/schedule/date/delete",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getOutOfLocation: builder.query<IApiResponse, IEmployeeScheduleDetailsPayload>({
      query: (request) => {
        return {
          url: "/punch/record/out-of",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getAllStaffDhashboardFrist: builder.query<IApiResponseDhashbordClient, IIdOnlyPayload>({
      query: (request) => {
        return {
          url: "/staff/dhashboard/frist",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getAttananceStaffDhashboard: builder.query<IApiResponse, IPayrollAnEmpPayloadSec2>({
      query: (request) => {
        return {
          url: "/staff/dhashboard/attendance",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getPayrollStaffDhashboard: builder.query<IApiResponse, IPayrollAnEmpPayload>({
      query: (request) => {
        return {
          url: "/staff/dhashboard/payroll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getAttananceMainDhashboard: builder.query<IApiResponse, IPayrollEmployee>({
      query: (request) => {
        return {
          url: "/staff/main/dhashboard/attendance",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["dashboard"],
      keepUnusedDataFor: 0,
    }),
    getPayrollStaffMainDhashboard: builder.query<IApiResponse, IPayrollAnEmpPayload>({
      query: (request) => {
        return {
          url: "/staff/main/dhashboard/payroll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    createSupplier: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/supplier',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['supplier', 'product'],
    }),
    deleteSupplier: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/supplier/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['supplier'],
    }),
    getSupplier: builder.query<IApiResponse, ISearchTagPayload>({
      query: (request) => {
        return {
          url: '/supplier/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['supplier', 'product'],
      keepUnusedDataFor: 0,
    }),
    deleteCapacity: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/capacity/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['capacity'],
    }),
    getCapacity: builder.query<IApiResponse, ISearchTagPayload>({
      query: (request) => {
        return {
          url: '/capacity/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['capacity', 'product'],
      keepUnusedDataFor: 0,
    }),
    createCapacity: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/capacity',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['capacity', 'product'],
    }),
    deleteGrade: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/grade/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['grade'],
    }),
    getGrade: builder.query<IApiResponse, ISearchTagPayload>({
      query: (request) => {
        return {
          url: '/grade/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['grade', 'product'],
      keepUnusedDataFor: 0,
    }),
    createGrade: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: '/grade',
          method: 'POST',
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ['grade', 'product'],
    }),
    createPriceCheckList: builder.mutation<IApiResponseForPunch, Object>({
      query: (request) => {
        return {
          url: "/price/check/list",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["OrderList", "PriceCheckList"],
    }),
    getPRCheckListHistroyRecord: builder.query<IApiResponse, ICheckProductStoreHistoPayload>({
      query: (request) => {
        return {
          url: '/price/check/price/list',
          method: "POST",
          body: request,
        };
      },
      providesTags: [ 'product'],
      keepUnusedDataFor: 0,
    }),
    getPriceCheckList: builder.query<IApiResponse, IPriceListPayload>({
      query: (request) => {
        return {
          url: '/price/check/getAll',
          method: "POST",
          body: request,
        };
      },
      providesTags:['PriceCheckList', 'product'],
      keepUnusedDataFor: 0,
    }),
    deletePriceCheckList: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/price/check/${Id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['PriceCheckList'],
    }),
    getLastPriceCheckListId: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/price/check/next-id",
          method: "GET",
        };
      },
      providesTags: ["PriceCheckList"],
      keepUnusedDataFor: 0,
    }),
    getPRCheckListHistroyTableRecord: builder.query<IApiResponse, ICheckProductStoreHistoPayload>({
      query: (request) => {
        return {
          url: '/price/check/price/list/table',
          method: "POST",
          body: request,
        };
      },
      providesTags: [ 'product'],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetUserQuery,
  useLoginMutation,
  useCreateSettingMutation,
  useGetSettingQuery,
  useCreateDepartmentMutation,
  useDeleteDepartmentMutation,
  useGetDepartmentQuery,
  useCreatePrinterMutation,
  useDeletePrinterMutation,
  useGetPrinterQuery,
  useCreateLoopingTableMutation,
  useGetAllLoopingTableQuery,
  useDeleteLoopingTableMutation,
  useUpdateLoopingTableMutation,
  useInsertOrUpdateDataLoopingTableMutation,
  useCreateCategoryMutation,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
  useGetLoopingTableQuery,
  useGetAllCategoryNameQuery,
  useDeleteCategoryMutation,
  useCreateProductMutation,
  useGetLastProductIdQuery,
  useGetSubCategoryByCategoryIdQuery,
  useDeleteProductMutation,
  useGetProductQuery,
  useGetProductCategoryQuery,
  useGetCategoryQuery,
  useCreateStoreMutation,
  useDeleteStoreMutation,
  useGetStoreQuery,
  useGetAllUserPrivilegesQuery,
  useCreateUserMutation,
  useGetUserAdminOnyQuery,
  useDeleteUserMutation,
  useChangeUserPasswordMutation,
  useUpdateUserPrivilegesMutation,
  useLazyGetAllCategoryNameQuery,
  useGetMissingPunchOutQuery,
  useGetStoreItemByCategoryQuery,
  useGetStoreItemByCategoryUpdatedQuery,
  useCreateOrderListMutation,
  useGetLastOrderListIdQuery,
  useGetOrderListQuery,
  useGetAllGetOrderListHistoryQuery,
  useCreateOrderListEditMutation,
  useDeleteOrderListHistoryMutation,
  useCreateUserRoleMutation,
  useDeleteUserRoleMutation,
  useGetUserRoleQuery,
  useCreateUserPrivilegeMutation,
  useGetUserPrivilegeQuery,
  useDeleteUserPrivilegeMutation,
  useChangeStatusOrderListSentToManagerMutation,
  useSentToManagerOrderListMutation,
  useGetOrderListByIdQuery,
  useAdminChangeStatusMutation,
  useGetAllAdminOrderListQuery,
  useAdminConformStorePriceQuery,
  useGetDashboardSecSectionOrderListQuery,
  useGetMainItemQuery,
  useCreateMainItemMutation,
  useCheckMainItemNameQuery,
  useCheckMainItemNameEditQuery,
  useDeleteMainItemMutation,
  useGetProductWithStoreQuery,
  useGetUserInfoOnyQuery,
  useCreateRestaurantMutation,
  useDeleteRestaurantMutation,
  useGetRestaurantQuery,
  useDeleteRestaurantScheduleMutation,
  useCreateDarkThemeColorMutation,
  useCreateLightThemeColorMutation,
  useGetAllDarkThemeColorQuery,
  useGetAllLightThemeColorQuery,
  useCreateTaxMutation,
  useDeleteTaxMutation,
  useGetTaxQuery,
  useGetAllMainCategory2Query,
  useGetMainItem2Query,
  useGetBrandQuery,
  useCreateBrandMutation,
  useCreateTagMutation,
  useDeleteBrandMutation,
  useDeleteTagMutation,
  useGetTagQuery,
  useCreateLightThemeColorOderMutation,
  useCreateDarkThemeColorOrderMutation,

  useCreateTeamMutation,
  useDeleteTeamMutation,
  useGetTeamQuery,
  useGetPunchDetailsQuery,
  useGetPunchDashboardQuery,
  useDeleteEmployeeScheduleMutation,
  useGetEmployeeScheduleDetailsQuery,
  useGetEmployeeScheduleDetailsByDateQuery,
  useGetEmployeeImgQuery,
  useCreatePositionMutation,
  useDeletePositionMutation,
  useGetPositionQuery,
  useGetEmployeePayRollQuery,
  useCreateAdminEditPunchMutation,
  useGetEmployeePayRollAdminQuery,
  useGetlastUpdateDatePayrollQuery,
  useCreateRescheduleMutation,
  useDeleteRescheduleMutation,
  useGetRescheduleQuery,
  useGetTeamSerchOnlyQuery,
  useGetEmployeeScheduleDetailsByDateOnlyQuery,
  useRemovedRescheduleMutation,
  useGetRescheduleOrderByDateQuery,
  useGetEmployeePayRollAdminUseMutation,
  useGetAnEmployeePayRollAdminQuery,
  useGetAllPayrollListQuery,
  useGetAllPayrollRecordeDateRangeQuery,
  useGetSaveEmployeePayrollRecordQuery,
  useGetSaveAnEmployeePayRollAdminQuery,
  useGetSaveAnEmplEachRecordPayRollAdminQuery,
  useGetPunchDetailsEmpQuery,
  useGetSaveEmployeePayrollAnEmployeeRecordQuery,
  usePayrollRecordeEmpQuery,
  useEditEmployeePayRollAdminQuery,
  useGetDayRecordAnEmplEachRecordQuery,
  useEmpPayrollPayrollRecordReportQuery,
  useEditPunchInTimeMutation,
  useEditPunchOutTimeMutation,
  useCreateRescheduleUpdatedForAllDateMutation,
  useGetEmpScheduleDetailsByDateRangeQuery,
  useCreatefixedPayrollGenerateMutation,
  useGetEmployeePayRollAdminUseEditMutation,
  useGetDashboardFristSectionQuery,
  useGetDashboardSecSectionQuery,
  useGetOrderListHistoryRecordByIdQuery,
  useAdminSetPriceOrderListMutation,
  useEditOrderListUpdatedPriceQuery,
  useGetAllGroupByStoreOrderListHistoryQuery,
  useGetProducStoreHistroyRecordQuery,
  useGetProducHistroyRecordQuery,
  useGetStoreItemOrderListQuery,
  useGetOrderListItemByStoreQuery,
  useGetOrderListReceiptQuery,
  useOrderListReceiptUpdateMutation,
  useGetAllDhashboardFristQuery,
  useCreateEmailMutation,
  useGetEmailQuery,
  useDeleteEmailMutation,
  useCreateEmailTemplatesMutation,
  useGetEmailTemplatesQuery,
  useDeleteEmailTemplatesMutation,
  useCreateEmailRecordMutation,
  useDeleteEmailRecordMutation,
  useGetEmailRecordQuery,
  useCreateUserStaffMutation,
  useDeleteUserStaffMutation,
  useDeleteAdminEditPunchMutation,
  useGetEmployeeScheduleDetailsByMonthQuery,
  useGetCheckAttananceStatusQuery,
  useGetEmpScheduleDetailsByDateDeleteRecordQuery,
  useGetOutOfLocationQuery,
  useGetAllStaffDhashboardFristQuery,
  useGetAttananceStaffDhashboardQuery,
  useGetPayrollStaffDhashboardQuery,
  useGetAttananceMainDhashboardQuery,
  useGetPayrollStaffMainDhashboardQuery,
  useCreateSupplierMutation,
  useDeleteSupplierMutation,
  useGetSupplierQuery,
  useDeleteCapacityMutation,
  useGetCapacityQuery,
  useCreateCapacityMutation,
  useCreateGradeMutation,
  useGetGradeQuery,
  useDeleteGradeMutation,
  useCreatePriceCheckListMutation,
  useGetPRCheckListHistroyRecordQuery,
  useGetPriceCheckListQuery,
  useDeletePriceCheckListMutation,
  useGetLastPriceCheckListIdQuery,
  useGetPRCheckListHistroyTableRecordQuery
} = attoDeskApi;
